export const validationPatterns = {
    url: { value: /^https?:\/\/.+\.[^\.]+/ }
}

export const autoPrefixUrlField = ({ e, set, key }) => {
    if (e.target.value && !/^https?:\/\//i.test(e.target.value)) {
        set(key, `https://${e.target.value}`)
    }
}
